import { GenericService } from './generic.service';
import { Order, OrderHistory } from '@/models';
import apiClient from './client/apiClient';
import { AxiosRequestConfig } from 'axios';

export class WebshopOrderService<T = OrderHistory> extends GenericService<T> {
  constructor(organisationId: string) {
    super(`v1/webshop/${organisationId}/orders`);
  }

  async getOrderDetail(orderId: string, config?: AxiosRequestConfig) {
    return await apiClient.get<Order>(`${this.endpoint}/${orderId}`, config);
  }

  async reorderItems(orderItemIds: string[], config?: AxiosRequestConfig) {
    return await apiClient.post(`${this.endpoint}/reorder`, { order_item_ids: orderItemIds }, config);
  }

  async getReceipt(orderId: string, config: AxiosRequestConfig = {}): Promise<string> {
    const data: Blob = await apiClient.get(`${this.endpoint}/${orderId}/pdf`, {
      ...config,
      responseType: 'blob'
    });
    return window.URL.createObjectURL(new Blob([data]));
  }

  async getOrdersByPatientId(organisationId: string, patientId: string, config?: AxiosRequestConfig) {
    return await apiClient.get<T[]>(
      `v1/webshop/${organisationId}/patients/${patientId}/orders`,
      config
    );
  }
}
